import { Stopwatch } from '@drift/common';
import { safeCheckDevSwitchIsOn } from '../hooks/useDevSwitchIsOn';
import posthog from 'posthog-js';

const doDlog = (key: string, message: any, ...optionalParams: any[]) => {
	console.debug(`🔧::${key}::\n${message}`, ...optionalParams);
};

const doDerr = (key: string, ...optionalParams: any[]) => {
	console.error(`🔧::ERROR_${key}`, ...optionalParams);
};

// Keywords that are allowed in production
const PROD_ALLOWED_KEYS = ['market_subscriptions'];
const PROD_ALLOWED_KEYS_LOOKUP = new Set(PROD_ALLOWED_KEYS);

// Dynamic set of allowed keys from PostHog
let posthogAllowedKeysLookup = new Set<string>();

// Update allowed keys from PostHog feature flags
const updatePostHogAllowedKeys = () => {
	const flagValue = posthog.getFeatureFlagPayload('DLOG_ALLOWED_KEYS');
	if (flagValue && Array.isArray(flagValue)) {
		// Filter out any non-string values and create a new Set
		posthogAllowedKeysLookup = new Set(
			flagValue.filter((value): value is string => typeof value === 'string')
		);
	} else {
		posthogAllowedKeysLookup.clear();
	}
};

// Listen for feature flag updates
posthog.onFeatureFlags(() => {
	updatePostHogAllowedKeys();
});

export function dlog(key: string, message: any, ...optionalParams: any[]) {
	/**
	 * Prod allowed keys
	 */
	if (PROD_ALLOWED_KEYS_LOOKUP.has(key)) {
		doDlog(key, message, ...optionalParams);
	}

	/**
	 * PostHog logging for whitelisted keys
	 */
	if (posthogAllowedKeysLookup.has(key)) {
		posthog.capture('dlog_event', {
			key,
			message: typeof message === 'object' ? JSON.stringify(message) : message,
			additional_params:
				optionalParams.length > 0 ? JSON.stringify(optionalParams) : undefined,
			url: window.location.href,
			timestamp: new Date().toISOString(),
			//@ts-ignore
			authority: window?.walletContext?.publicKey?.toString(),
		});
	}

	if (process.env.NEXT_PUBLIC_ENV === 'mainnet-beta') {
		if (!safeCheckDevSwitchIsOn()) return;
	}

	doDlog(key, message, ...optionalParams);
}

export function derr(key: string, ...optionalParams: any[]) {
	if (process.env.NEXT_PUBLIC_ENV === 'mainnet-beta') {
		if (!safeCheckDevSwitchIsOn()) return;
	}

	doDerr(key, ...optionalParams);
}

export const DEV_STOPWATCH = new Stopwatch();
